<template>
  <div class="Page">
    <HeaderSection 
      title="Over de Renovatieversneller Monitor"
      :closeLinkTo="{ name: 'home'}">
      <p>
        Op dit platform presenteren we interessante en leerzame projecten die gaan over de energietransitie in woningen
      </p>
    </HeaderSection>

    <ContentSection>
      <SectionHeader label="Doel: Overzicht &amp; Inzicht" />
      <p>
        Stukje over creeren van (ruimtelijk) overzicht en inzicht in verbindingen.
      </p>
      <p>
        ...
      </p>
      
    </ContentSection>
    <ContentSection>
      <SectionHeader label="De Renovatieversneller" />
      <p>
        Stukje over De Renovatieversneller
      </p>
      <p>
        ...
      </p>
      
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/section/ContentSection';
import HeaderSection from '@/components/section/HeaderSection';
import SectionHeader from '@/components/section/Header';
// import Link from '@/components/Link';

export default {
  name: 'PageAbout',
  components: {
    HeaderSection,
    ContentSection,
    SectionHeader,
    // Link
  }
}
</script>
